import React, { useEffect, useState } from 'react';
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import styles from './Film.module.css';
import FilmScores from './FilmScores';
import SoundDesign from './SoundDesign';
import SoundRecordist from './SoundRecordist';
import { trackTabInteraction, trackNavigation } from '../utils/analytics';

const TABS = [
  { id: 1, label: 'Film Scores', path: 'filmscores' },
  { id: 2, label: 'Sound Design', path: 'sounddesign' },
  { id: 3, label: 'Sound Recordist', path: 'soundrecordist' },
];

const Film = () => {
  const location = useLocation();
  const [active, setActive] = useState(1);

  useEffect(() => {
    if (location.pathname.includes('sounddesign')) setActive(2);
    else if (location.pathname.includes('soundrecordist')) setActive(3);
    else setActive(1);
  }, [location]);

  return (
    <div className={styles.container}>
      <div className={styles.tabs}>
        {TABS.map(tab => (
          <Link
            key={tab.id}
            to={tab.path}
            className={`${styles.tab} ${active === tab.id ? styles.activeTab : ''}`}
            onClick={() => {
              trackTabInteraction(tab.label, 'switch');
              trackNavigation(tab.label, `/film/${tab.path}`);
              setActive(tab.id);
            }}
          >
            {tab.label}
          </Link>
        ))}
      </div>
      <div className={styles.content}>
        <Routes>
          <Route path="filmscores" element={<FilmScores />} />
          <Route path="sounddesign" element={<SoundDesign />} />
          <Route path="soundrecordist" element={<SoundRecordist />} />
        </Routes>
      </div>
    </div>
  );
};

export default Film;
